import { RoutingUtilitiesService } from '../_services/routingUtlities.service';

let loaderService: RoutingUtilitiesService | null = null;

export function setRoutingLoaderService(service: RoutingUtilitiesService) {
  loaderService = service;
}
